import { styled } from '@mui/material/styles';
import { FormControl, Box, Typography, Stack } from '@mui/material';

export const StyledFormControl = styled(FormControl)({
  width: '100%'
});

export const InfoBox = styled(Box)(({ theme }) => ({
  width: '100%',
  color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'center'
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  width: theme.spacing(30),
  marginTop: 0
})); 

export const SubmitButtonContainer = styled(Box)(({ theme }) => ({
  paddingTop: '1.5rem',
  width: '100%'
}));

export const ForgotPasswordContentStack = styled(Stack)({
  marginTop: '2.4rem',
  width: '100%'
});